import { trpc } from "@/lib/trpc";
import { toast } from "sonner";
import { fromError } from "zod-validation-error";

export const useCreateVectorStoreProviderMutation = (setLoading?: (loading: boolean) => void, setError?: (error: string) => void) => {
    const utils = trpc.useUtils();
    return trpc.vectorStoreProviders.create.useMutation({
        onMutate: async () => {
            setLoading?.(true);
            setError?.("");
        },
        onSuccess: async () => {
            utils.vectorStoreProviders.findAll.invalidate();
            toast.success("Vector store provider created successfully");
        },
        onError: async (error: any) => {
            const errorMessage = fromError(error).toString();
            toast.error(errorMessage);
            setError?.(errorMessage);
        },
        onSettled: async () => {
            setLoading?.(false);
        },
    });
};

export const useUpdateVectorStoreProviderMutation = (setLoading?: (loading: boolean) => void, setError?: (error: string) => void) => {
    const utils = trpc.useUtils();
    return trpc.vectorStoreProviders.update.useMutation({
        onMutate: async () => {
            setLoading?.(true);
            setError?.("");
        },
        onSuccess: async (data) => {
            utils.vectorStoreProviders.findAll.invalidate();
            utils.vectorStoreProviders.findById.invalidate({ id: data.id });
            utils.vectorStoreProviders.findByProvider.invalidate({ provider: data.provider });
            toast.success("Vector store provider updated successfully");
        },
        onError: async (error: any) => {
            const errorMessage = fromError(error).toString();
            toast.error(errorMessage);
            setError?.(errorMessage);
        },
        onSettled: async () => {
            setLoading?.(false);
        },
    });
};

export const useSetEnabledVectorStoreProviderMutation = () => {
    const utils = trpc.useUtils();
    return trpc.vectorStoreProviders.setEnabled.useMutation({
        onSuccess: async (data) => {
            utils.vectorStoreProviders.findAll.invalidate();
            utils.vectorStoreProviders.findEnabled.invalidate();
            toast.success(`Vector store provider ${data.enabled ? "enabled" : "disabled"} successfully`);
        },
        onError: async (error: any) => {
            const errorMessage = fromError(error).toString();
            toast.error(errorMessage);
        },
    });
};

export const useDeleteVectorStoreProviderMutation = () => {
    const utils = trpc.useUtils();
    return trpc.vectorStoreProviders.delete.useMutation({
        onSuccess: async () => {
            utils.vectorStoreProviders.findAll.invalidate();
            toast.success("Vector store provider deleted successfully");
        },
        onError: async (error: any) => {
            const errorMessage = fromError(error).toString();
            toast.error(errorMessage);
        },
    });
};
